import { PureComponent } from "react";
import { componentStyles } from "./manage-options-component.scss";
import ManageOptionComponent from "./manage-option-component";

export default class ManageOptionsComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.renderOption = this.renderOption.bind(this);
  }

  renderOption(option) {
    const { onSelect, selectedOptions } = this.props;

    const isSelected = selectedOptions.indexOf(option) > -1;
    return <ManageOptionComponent optionText={option} onSelect={onSelect} isSelected={isSelected} key={option} />;
  }

  render() {
    const { options } = this.props;

    return (
      <div className="manage-options-wrapper">
        {options.map(option => this.renderOption(option))}

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
